import { isEdlEnabled } from '@/components/TopBar/edlAccess'
import { investorBeforeEnter } from '@/router/rules/investorBeforeEnter'

// Garde des écrans « État des lieux ». Un compte QUI N'A PAS accès (non abonné payant, ou
// non connecté) est redirigé vers l'abonnement, même s'il tape l'URL en direct :
// /my-subscription gère tous les cas et bascule vers la page des offres (horiz.io/offres)
// pour qui n'a pas d'abonnement. Un abonné payant passe ensuite le garde investisseur
// habituel (onboarding si aucun bien).
//
// IMPORTANT (Vue Router 4) : NE PAS déclarer le paramètre `next`. Dès qu'un garde a une
// arité >= 3, Vue Router attend un appel explicite à next() et n'utilise PAS la valeur de
// retour -> la navigation reste bloquée à l'infini (l'écran ne se charge jamais). En arité 2,
// la valeur retournée (true | chemin de redirection) est appliquée automatiquement, comme
// investorBeforeEnter (arité 0). Ne jamais réintroduire `next` ici.
export const edlBeforeEnter = async (to, from) => {
  if (!isEdlEnabled()) {
    return '/my-subscription'
  }

  return investorBeforeEnter(to, from)
}
